import React from 'react';
import { ReactComponent as ProductOptionsIcon } from 'qs-assets/Media/product-options.svg';
import './styles.scss';

export default ({ width, height, fill, classes = '' }) => {
  return (
    <ProductOptionsIcon
      style={{ width, height, fill }}
      className={`settingsIconComponent ${classes}`}
    />
  );
};
